import { EventEmitter, Injectable } from '@angular/core';
import { CheckPlatformService } from '@services/helpers/check-platform.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public hideShowLoading: EventEmitter<boolean> = new EventEmitter();
  constructor(private checkPlatformService: CheckPlatformService) {}

  hide = () => {
    const loader = this.checkPlatformService.isBrowser() ? document.getElementById('loader-main') : null;
    if (!loader) return;
    loader.style.display = 'none';
    loader.style.backgroundColor = 'none';
  };

  show = () => {
    const loader = this.checkPlatformService.isBrowser() ? document.getElementById('loader-main') : null;
    if (!loader) return;
    loader.style.display = 'flex';
    loader.style.backgroundColor = '#00000029';

    setTimeout(() => {
      this.hide();
    }, 6000);
  };
}
